<div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

    <div class="logo">
        <img class="logo-text" src="assets/images/logos/Coexito.png">
        <img class="logo-icon" src="assets/images/logos/Icoexito.png">
    </div>

    <div class="buttons">

        <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebarFolded()" fxHide.lt-lg>
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" fxHide.gt-md>
            <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>

    </div>

</div>


<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground" fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <div class="user" fxLayout="column" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

        <div class="h3 username">{{usuario.nombre}}</div>
        <div class="h5 email hint-text mt-8">{{usuario.email}}</div>
        <div class="avatar-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
            <img class="avatar" src="assets/images/avatars/sinNombre.png">
        </div>

    </div>

    <div class="navbar-content" fxLayout="column">
        <fuse-navigation fxLayout="column" class="material2" [layout]="'vertical'"></fuse-navigation>

        <div fxLayoutAlign="end center" fxLayout="column" fxFlex="100" class="py-20 logo">
            <button mat-raised-button class="submit-button btnlogin mb-8 logo-icon" aria-label="LOG IN"
                (click)="logout()">
                <mat-icon class="s-30 secondary-text">exit_to_app</mat-icon>
                <div class="btn-text">{{'lbl.logout' | translate}}</div>
            </button>
            <mat-divider></mat-divider>
            <div class="logo-vortexbird pt-12">
                <a href="https://www.vortexbird.com">
                    <img src="assets/images/logos/Vortexbird.png">
                </a>
            </div>
        </div>
    </div>


</div>